var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C9.72905 3 3 9.72906 3 18C3 26.2709 9.72905 33 18 33C26.271 33 33 26.2709 33 18C33 9.72906 26.271 3 18 3ZM18 5.25C25.055 5.25 30.75 10.945 30.75 18C30.75 25.055 25.055 30.75 18 30.75C10.945 30.75 5.25 25.055 5.25 18C5.25 10.945 10.945 5.25 18 5.25Z",
    fill: "#9DA4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1931 10.0747C17.4007 9.86109 17.6846 9.7385 17.9824 9.73384C18.1329 9.73149 18.2823 9.75934 18.4217 9.81575C18.5612 9.87215 18.688 9.95596 18.7945 10.0622C18.9011 10.1685 18.9852 10.295 19.042 10.4344C19.0987 10.5737 19.127 10.723 19.125 10.8735V19.8735C19.1271 20.0226 19.0996 20.1706 19.044 20.3089C18.9884 20.4473 18.9059 20.5732 18.8012 20.6793C18.6965 20.7855 18.5718 20.8698 18.4342 20.9273C18.2967 20.9849 18.1491 21.0145 18 21.0145C17.8509 21.0145 17.7033 20.9849 17.5658 20.9273C17.4282 20.8698 17.3035 20.7855 17.1988 20.6793C17.0941 20.5732 17.0116 20.4473 16.956 20.3089C16.9004 20.1706 16.8729 20.0226 16.875 19.8735V10.8735C16.8711 10.5756 16.9855 10.2884 17.1931 10.0747Z",
    fill: "#9DA4AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9393 23.6878C17.2206 23.4065 17.6022 23.2485 18 23.2485C18.3978 23.2485 18.7794 23.4065 19.0607 23.6878C19.342 23.9691 19.5 24.3507 19.5 24.7485C19.5 25.1463 19.342 25.5278 19.0607 25.8092C18.7794 26.0905 18.3978 26.2485 18 26.2485C17.6022 26.2485 17.2206 26.0905 16.9393 25.8092C16.658 25.5278 16.5 25.1463 16.5 24.7485C16.5 24.3507 16.658 23.9691 16.9393 23.6878Z",
    fill: "#9DA4AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamatory);
export default __webpack_public_path__ + "static/media/Exclamatory.b20b2104cbe439e55217ab243dc9796b.svg";
export { ForwardRef as ReactComponent };